import CarvanaLoadingSpinner from '@carvana/loading-spinner';
import { Clickable, OnEscapeListener } from '@carvana/merch-components';
import { useContext, useEffect } from 'react';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import {
  Close,
  CloseButton,
  SpinnerOverlayLoader
} from '../LiteGallery.styles';

type OwnProps = {
  cancelSpinnerLoad: () => void;
  setTransitionOverlay: (value: boolean) => void;
  transitionOverlay: boolean;
};

const SpinnerOverlay = ({
  cancelSpinnerLoad,
  setTransitionOverlay,
  transitionOverlay
}: OwnProps) => {
  const { isSpinnerImmersive } = useContext(SpinnerContext);

  useEffect(() => {
    setTransitionOverlay(!isSpinnerImmersive);
  }, [isSpinnerImmersive, setTransitionOverlay]);

  return (
    <OnEscapeListener onEscape={cancelSpinnerLoad}>
      <SpinnerOverlayLoader
        className={transitionOverlay ? 'opacity-100' : 'opacity-0'}
      >
        <CarvanaLoadingSpinner className="z-0 m-auto h-full" />
        <Clickable
          data-analytics-id="Spinner Overlay - Close"
          element={CloseButton}
          onClick={cancelSpinnerLoad}
        >
          <Close />
        </Clickable>
      </SpinnerOverlayLoader>
    </OnEscapeListener>
  );
};

export default SpinnerOverlay;
